<template>
  <div class="companyBox">
    <navigation></navigation>
    <div class="homeBG"></div>

    <!-- 岗位列表 -->
    <div class="jobBox" v-if="!selectedJob">
      <div class="job-item" v-for="(item, index) in workListData" :key="index" @click="showJobDetail(item)">
        <div class="job-item-header">
          <div class="job-name">{{ item.jobName }}</div>
          <div class="job-count">{{ item.recruitNumber }}</div>
        </div>

        <div class="job-meta">
          <span>{{ item.educationRequirement }}</span>
          <span>{{ item.salaryRange }}</span>
          <span>{{ item.otherRequirements || '专业性强' }}</span>
        </div>
      </div>
    </div>

    <!-- 岗位详情 -->
    <div class="job-detail-wrapper" v-else>
      <div class="detail-header">
        <button class="back-btn" @click="goBack">← 返回岗位列表</button>
      </div>

      <div class="job-detail-container">
        <div class="job-header">
          <h1 class="job-title">{{ selectedJob.jobName }}</h1>
          <div class="job-meta-info">

            <span class="meta-tag">{{ selectedJob.recruitNumber }}</span>
            <span class="meta-tag">{{ selectedJob.educationRequirement }}</span>
            <span class="meta-tag">{{ selectedJob.salaryRange }}</span>
          </div>
        </div>



        <div class="job-section">
          <h3>任职要求</h3>
          <div class="job-requirements">
            {{ selectedJob.jobRequirements || '暂无具体要求' }}
          </div>
        </div>
        <div class="job-section">
          <h3>职位描述</h3>
          <div class="job-description">
            {{ selectedJob.jobResponsibilities || '暂无详细描述' }}
          </div>
        </div>
        <div class="job-section">
          <h3>个人发展</h3>
          <div class="job-description">
            {{ selectedJob.personalDevelopment || '暂无详细描述' }}
          </div>
        </div>
        <div class="job-section">
          <h3>工作福利</h3>
          <div class="job-description">
            {{ selectedJob.workBenefits || '暂无详细描述' }}
          </div>
        </div>
        <div class="job-section">
          <span style="font-size: 20px; font-weight: 700;">
            联系人姓名： 李女士 &nbsp;&nbsp;&nbsp;联系人电话：025-84939007 (周一至周五 8:00-16:00)
          </span>
        </div>
      </div>
    </div>

    <dibu></dibu>
  </div>
</template>

<script>
import navigation from '@/views/navigation.vue'
import dibu from './dibu.vue';
import axios from 'axios';

export default {
  name: 'CompanyProfile',
  data() {
    return {
      workListData: [],
      selectedJob: null
    }
  },
  mounted() {
    this.renderJobList()
  },
  methods: {
    async renderJobList() {
      try {
        let res = await axios.get('https://3521hb.com/api/job/selectAll?status=1')
        this.workListData = res.data.data
        console.log('岗位数据:', res.data.data)
      } catch (error) {
        console.error('获取岗位列表失败:', error)
      }
    },

    showJobDetail(job) {
      this.selectedJob = job
      console.log(job);


    },

    goBack() {
      this.selectedJob = null
      // 滚动回原来的位置
      setTimeout(() => {
        window.scrollTo({ top: 800, behavior: 'smooth' }) // homeBG的高度
      }, 100)
    }
  },
  components: {
    navigation,
    dibu
  }
}
</script>

<style lang="scss" scoped>
.companyBox {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
   position: relative;

  .homeBG {
    width: 100%;
    height: 800px;
    background-image: url('../img/wzdh.png');
    background-size: 100% 100%;
  }

  /* 原有岗位列表样式保持不变 */
  .jobBox {
    padding: 40px;
    padding-left: 200px;
    padding-right: 200px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
    justify-content: center;
  }

  .job-item {
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    margin-bottom: 15px;
    padding: 20px;
    box-sizing: border-box;
    width: 500px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .job-item:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  .job-item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }

  .job-name {
    font-size: 20px;
    font-weight: bold;
    color: #333;
  }

  .job-count {
    font-size: 16px;
    color: #666;
    background: #f0f0f0;
    padding: 4px 12px;
    border-radius: 15px;
  }

  .job-meta {
    display: flex;
    gap: 20px;
    font-size: 14px;
    color: #888;
  }

  .job-meta span {
    background: #f8f8f8;
    padding: 2px 8px;
    border-radius: 10px;
  }

  /* 新增详情页样式 */
  .job-detail-wrapper {
    padding: 40px;
    max-width: 1000px;
    margin: 0 auto;
    margin-top: 20px;
  }

  .detail-header {
    margin-bottom: 30px;

    .back-btn {
      background: none;
      border: none;
      color: #007bff;
      font-size: 16px;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 4px;
      transition: background-color 0.3s;
      display: inline-flex;
      align-items: center;

      &:hover {
        background-color: #f8f9fa;
      }
    }
  }

  .job-detail-container {
    background: #fff;
    border-radius: 8px;
    padding: 40px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .job-header {
    margin-bottom: 30px;
    text-align: center;

    .job-title {
      font-size: 28px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
    }

    .job-meta-info {
      display: flex;
      justify-content: center;
      gap: 15px;
      flex-wrap: wrap;

      .meta-tag {
        background: #f8f9fa;
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 14px;
        color: #666;
        border: 1px solid #e9ecef;
      }
    }
  }

  .job-section {
    margin-bottom: 30px;

    h3 {
      color: #333;
      font-size: 20px;
      border-bottom: 2px solid #007bff;
      padding-bottom: 8px;
      margin-bottom: 20px;
    }
  }

  .job-description,
  .job-requirements,
  .job-other-info {
    color: #666;
    line-height: 1.8;
    font-size: 16px;

    p {
      margin-bottom: 10px;
    }

    strong {
      color: #333;
    }
  }

  /* 响应式设计 */
  @media (max-width: 768px) {
    .homeBG{
      height: 400px;
    }
    .jobBox {
      padding-left: 20px;
      padding-right: 20px;
    }

    .job-item {
      width: 100%;
      max-width: 400px;
    }

    .job-detail-wrapper {
      padding: 20px;
    }

    .job-detail-container {
      padding: 20px;
    }

    .job-header .job-meta-info {
      flex-direction: column;
      align-items: center;

      .meta-tag {
        width: fit-content;
      }
    }
  }
}
</style>